import { requestApi } from '../util/network'

// 1.	手机端兑换代金券接口
export const getPointbycode =
    (code) =>
      requestApi(
        '/Membervoucher/voucher_pointbycode',
        'POST',
        {
          'code': code, // 所属店铺
        },
        'member'
      )
// 获取用户代金券列表
export const getVoucherList =
(params) =>
  requestApi(
    '/Membervoucher/voucher_list',
    'POST',
    {
        page:params.page,
        per_page:params.per_page,
        voucher_state:params.voucher_state
    },
    'member'
  )
// 代金券统计说明
export const getVoucherCount =
    (voucher_state) =>
      requestApi(
        '/Membervoucher/voucher_count',
        'POST',
        {
          'voucher_state': voucher_state
        },
        'member'
      )
